import { Dag, DagStatus } from '@agilelab/plugin-wb-builder-common';
import { FC, useMemo } from 'react';
import { Test } from '../../../ControlPanel';
import { useBugIcons } from '../../hooks/useBugIcons';

interface Props {
  step: Dag;
  tests?: Test;
}

export const ValidationGatewayStep: FC<Props> = ({ step, tests }) => {
  const bugIcons = useBugIcons();

  const validationGatewayStatus = useMemo(() => {
    if (step.status === DagStatus.COMPLETED) {
      const hasNotBlockingError = tests?.tasks?.some(
        x =>
          x.status === DagStatus.WARNING ||
          x.status === DagStatus.INFO ||
          x.status === DagStatus.NOT_BLOCKING_ERROR,
      );
      if (hasNotBlockingError) return DagStatus.NOT_BLOCKING_ERROR;

      return step.status;
    }
    return step.status;
  }, [tests, step]);

  return <>{bugIcons[validationGatewayStatus]}</>;
};
